var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFramework(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7,40c-0.8,0-1.6-0.3-2.1-0.9C4.3,38.6,4,37.8,4,37V11c0-0.8,0.3-1.6,0.9-2.1C5.4,8.3,6.2,8,7,8h34c1.6,0,3,1.4,3,3v26c0,1.6-1.4,3-3,3L7,40L7,40z M7,37h34V15.2H7V37L7,37z M15,33.4l-2.1-2.1l5.1-5.2l-5.2-5.2l2.1-2.1l7.4,7.3L15,33.4z M24.5,33.6v-3h11v3H24.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFramework);
export default __webpack_public_path__ + "static/media/framework.2bede8c9c02b42592613ccfa19f7d94e.svg";
export { ForwardRef as ReactComponent };